import { render, staticRenderFns } from "./imitMyPract.vue?vue&type=template&id=67e9f58e&scoped=true&"
import script from "./imitMyPract.vue?vue&type=script&lang=js&"
export * from "./imitMyPract.vue?vue&type=script&lang=js&"
import style0 from "./imitMyPract.vue?vue&type=style&index=0&id=67e9f58e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9f58e",
  null
  
)

export default component.exports